<div>
  <a
    *showAuthed="currentUser"
    href="javascript:"
    (click)="generalNotificationModal.show()"
  >
    <i class="ti-bell"></i>
    <span *ngIf="hasNotifications" class="badge bg-c-green"></span>
  </a>

  <!-- General notifications alert modal -->
  <notification-alerts-modal
    #generalNotificationModal
    [limit]="2"
    [config]="config"
    [currentUser]="currentUser"
    (confirmAlert)="alertUser($event)"
    [hideFooter]="true"
  >
  </notification-alerts-modal>
  <!-- General notification alert modal -->
</div>
